import React from 'react'
import { useTranslation } from 'react-i18next'
import PortfolioGallery from '../../components/PortfolioGallery'
import PageSEO from '@/components/SEO/PageSEO'
import { portfolioProjects } from './data'

type PortfolioProps = {
  embedded?: boolean
}

const Portfolio = ({ embedded = false }: PortfolioProps) => {
  const { t } = useTranslation()

  return (
    <>
      {!embedded && (
        <PageSEO
          title={`${t('my_portfolio.title')} - Minh Nguyen`}
          description={t('my_portfolio.subtitle')}
          path="/portfolio"
          keywords={['portfolio', 'projects', 'web development', 'react']}
        />
      )}
      <PortfolioGallery
        images={portfolioProjects}
        title={t('my_portfolio.title')}
        embedded={embedded}
      />
    </>
  )
}

export default Portfolio
